import React, { useEffect } from "react";
import { Box, Divider, Grid2, styled, Tab, Tabs, Typography, useTheme } from "@mui/material";
import ScheduleMonitoringTracking from "./ScheduleMonitoringTracking";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import RiskDashBoard from "./Risk";
import Cost from "./Cost";
import Procurement from "./Procurement";
import ClaimAndChangeOrder from "./ClaimAndChangeOrder";
import ProjectLandingDashboard from "./ProjectLandingDashboard";

import tabs from "components/subTabs-items/tabs";
import { useCheckMenuPermission } from "hooks/useCheckMenuPermission";

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "none", // Prevent uppercase
  fontWeight: "400",
  fontSize: "16px",
  color: "#696969",
  padding: '0px',
  minHeight: '0px',
  minWidth: '0px',
  margin: '0px 15px 5px 15px',
  // Apply different margin for the first tab
  "&:first-of-type": {
    marginLeft: "0px", // Set margin-left to 0 for the first tab
  },
  "&.Mui-selected": {
    color: `${theme?.customSettings?.themeColor}`, // Selected tab color
  }
}));


// const tabs = [
//   { label: "Home", path: "project-landing", index: 0, icon: <MdOutlineHome style={{ fontSize: '20px' }} />, permissionKey: [PROJECT_HOME_ACCESS] },
//   { label: "Project Progress and Scheduling", path: "schedule", index: 1, icon: <MdOutlineSchedule style={{ fontSize: '20px' }} />, permissionKey: [SMT_SCHEDULE_ACCESS, SMT_CONSTRUCTION_ACCESS, SMT_MILESTONE_ACCESS, SMT_ENGINEERING_ACCESS, SMT_PM_ACCESS, SMT_MANPOWERPRODUCT_ACCESS] },
//   { label: "Project Cost Control", path: "cost", index: 2, icon: <FaIndianRupeeSign />, permissionKey: [FINANCIAL_PROGRESS_DASH_ACCESS, PAYMENT_TRACKER_DASH_ACCESS] },
//   { label: "Contract and Procurement Lifecycle", path: "procurement", index: 3, icon: <IoIosDocument />, permissionKey: [VENDOR_DASH_ACCESS, PROCUREMENT_DASH_ACCESS] },
//   { label: "Change Control & Claim Tracker", path: "claims-and-changeorder", index: 4, icon: <FaFileContract />, permissionKey: [CLAIM_AND_CHANGE_ORDER_DASH_ACCESS] },
//   { label: "Integrated Risk Control Centre", path: "risk", index: 5, icon: <FaList />, permissionKey: [ISSUES_DASH_ACCESS, KEY_CLEATANCE_DASH_ACCESS, RISK_DASH_ACCESS, SAFETY_DASH_ACCESS, QUALITY_DASH_ACCESS] },
// ];

const ProjectLanding = () => {
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission } = useCheckMenuPermission();
  const currentTab = tabs.find(tab => tab.path === searchParams.get("type"));
  const tabIndex = currentTab ? currentTab.index : 0;

  const handleChange = (_, newIndex) => {
    const newTab = tabs.find(tab => tab.index === newIndex);
    
    if (newTab) {
      // const storageKey = `${newTab.path}TabIndex`;
      // localStorage.setItem(storageKey, "0");
      navigate(`?type=${newTab.path}`);
    }
  };



  useEffect(() => {
    // const contentDiv = document.querySelector(`.${styles.content}`);
    // if (contentDiv) {
    //   contentDiv.style.padding = "0";
    // }
  }, [location.pathname]);

  return (
    <>
      <Grid2 container spacing={2} sx={{ mt: '20px' }}>
        <Grid2 size={12}>
          <Typography variant="h5" sx={{ fontSize: '24px', fontWeight: '500', color: '#252525', mb: 2, lineHeight: "32px", letterSpacing: '-0.4px' }}>
            Project Dashboard
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Box sx={{ width: "100%" }}>
            {/* <Box sx={{ borderBottom: 2, borderColor: "#fff" }}> */}
            <Tabs
              value={tabIndex}
              onChange={handleChange}
              aria-label="URL-based tabs"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              sx={{
                minHeight: "0px",
                "& .MuiTabs-indicator": { backgroundColor: `${theme?.customSettings?.themeColor}` },
              }}
            >
              {tabs?.filter(item => hasPermission(item?.permissionKey) > 0)?.map(tab => (
                <StyledTab key={tab.index} label={tab.label} value={tab.index} disabled={tab.disabled} icon={tab?.icon} iconPosition="start" />
              ))}
            </Tabs>
            {/* </Box> */}
            <Divider sx={{ borderColor: '#fff', borderBottomWidth: "initial" }} />
            {searchParams.get("type") == 'project-landing' && (
              <ProjectLandingDashboard />
            )}
            {searchParams.get("type") == 'risk' && (
              <RiskDashBoard />
            )}
            {searchParams.get("type") == 'procurement' && (
              <Procurement />
            )}
            {searchParams.get("type") == 'cost' && (
              <Cost />
            )}
            {searchParams.get("type") == 'claims-and-changeorder' && (
              <ClaimAndChangeOrder />
            )}
            {searchParams.get("type") == 'schedule' && (
              <ScheduleMonitoringTracking />
            )}
          </Box>
        </Grid2>
      </Grid2>
    </>
  );
};

export default ProjectLanding;